import type { OnDestroy, Signal } from '@angular/core'
import { computed, Injectable, inject } from '@angular/core'
import { SignalQuery } from '@awork/core/state/signal-store/signalQuery'
import type { FeatureFlagKey, FeatureFlagDefinition, FeatureFlagType } from '@awork/_shared/state/feature-flag.store'
import { FeatureFlag, FeatureFlagStore } from '@awork/_shared/state/feature-flag.store'

@Injectable({ providedIn: 'root' })
export class FeatureFlagQuery extends SignalQuery<FeatureFlagDefinition> implements OnDestroy {
  protected store: FeatureFlagStore

  static instance: FeatureFlagQuery // Used to query the store in models (user, company, etc.)

  constructor() {
    const store = inject(FeatureFlagStore)

    super(store)

    this.store = store
  }

  /**
   * Clears the static reference when Angular destroys this query.
   */
  ngOnDestroy(): void {
    if (FeatureFlagQuery.instance === this) {
      Reflect.deleteProperty(FeatureFlagQuery, 'instance')
    }
  }

  /**
   * Gets the value of a feature flag
   * @param {K} flag
   * @returns {Signal<FeatureFlagType<K>>}
   */
  queryFlag<K extends FeatureFlag>(flag: K): Signal<FeatureFlagType<K>> {
    return computed(() => {
      const flagKey = Object.keys(FeatureFlag).find(key => FeatureFlag[key] === flag)
      const featureFlag = this.query(flagKey as FeatureFlagKey) as Signal<FeatureFlagType<K>>

      return featureFlag()
    })
  }
}
